import React from 'react';
import './LandingPage.css';

export default function Division() {
  return (
    <main className="container" style={{ padding: 24 }}>
      <h1>Division</h1>
      <p>Page to manage divisions (placeholder).</p>
    </main>
  );
}
